import api, { APIURL, authenHeader, errorHandle } from "../api/api"

class Email {
    constructor(obj) {
        this.id = obj.ID
        this.name = obj.name
        this.title = obj.title
        this.body = obj.body
        this.note = obj.note
        if (obj.email_type) {
            this.type = obj.email_type
        }
        else if (obj.type) {
            this.type = obj.type
        }
        this.fix = obj.fix
        this.updated_at = obj.UpdatedAt
    }

    serialized() {
        return {
            "name": this.name,
            "title": this.title,
            "body": this.body,
            "note": this.note,
            "type": this.type?.value,
            "fix": this.fix
        }
    }
}

export default Email

export const getAllEmails = (mode,token) => {
    const headers = {
        headers: authenHeader(token)
    }
    var query = ""
    if(mode){
        query = `?type=${mode}`
    }
    return new Promise((resolve, reject) => {
        api.get(APIURL.EMAIL(query), headers)
            .then(res => {
                if (res.data.data) {
                    const list = res.data.data?.map(i => new Email(i))
                    resolve(list)
                } else {
                    resolve(res.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })
    })
}

export const getEmail = (id, token) => {
    const headers = {
        headers: authenHeader(token)
    }

    return new Promise((resolve, reject) => {
        api.get(APIURL.EMAIL(id), headers)
            .then(res => {
                if (res.data.data) {
                    const obj = new Email(res.data.data)
                    resolve(obj)
                } else {
                    resolve(res.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })
    })
}

export const createEmail = (data, token) => {
    const headers = {
        headers: authenHeader(token)
    }

    return new Promise((resolve, reject) => {
        api.post(APIURL.EMAIL(), data, headers)
            .then(res => {
                if (res.data.data) {
                    const obj = new Email(res.data.data)
                    resolve(obj)
                } else {
                    resolve(res.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })
    })
}

export const updateEmail = (id, data, token) => {
    const headers = {
        headers: authenHeader(token)
    }

    return new Promise((resolve, reject) => {
        api.put(APIURL.EMAIL(id), data, headers)
            .then(res => {
                if (res.data.data) {
                    const obj = new Email(res.data.data)
                    resolve(obj)
                } else {
                    resolve(res.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })
    })
}

export const deleteEmail = (id, token) => {
    const headers = {
        headers: authenHeader(token)
    }

    return new Promise((resolve, reject) => {
        api.delete(APIURL.EMAIL(id), headers)
            .then(res => {
                resolve(res.data)
            })
            .catch(error => {
                reject(errorHandle(error))
            })
    })
}